import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-my-edit',
  templateUrl: 'my-edit.html'
})
export class MyEditPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goBack(params){
    if (!params) params = {};
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/my-edit/my-edit.ts